var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 57,
    viewBox: "0 0 53 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6729 14.25H52.9985L35.1264 57H22.8008L40.6729 14.25Z",
    fill: "#2C20DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.343 0H41.5988L17.2558 57H0L24.343 0Z",
    fill: "#6C82EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlash);
export default __webpack_public_path__ + "static/media/Slash.d73a1f7fac39dda81986638988ebb908.svg";
export { ForwardRef as ReactComponent };